export default __webpack_public_path__ + "static/media/news (3).4ea4e369.webp";